document.addEventListener("click", (event) => {

  const pill = event.target.closest(".quote-code-banner__pill");
  if (!pill) return;

  const group = pill.closest(".quote-code-banner__pills");
  if (group) {
    group.querySelectorAll(".quote-code-banner__pill").forEach(p => p.classList.remove("is-active"));
  }
  pill.classList.add("is-active");

  const code = pill.getAttribute("data-copy-code");
  if (!code) return;

  const copyToClipboard = (text) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).catch(() => fallbackCopy(text));
    } else {
      fallbackCopy(text);
    }
  };

  copyToClipboard(code);

});

function fallbackCopy(text) {
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  try {
    document.execCommand("copy");
  } catch (err) {
    // silently ignore if copy fails
  }
  document.body.removeChild(textarea);
}